/**
 * GB API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldMetaData } from './fieldMetaData';
import { HistInfoMeta } from './histInfoMeta';
import { EigentumanteilVersionIdMeta } from './eigentumanteilVersionIdMeta';
import { Bruch } from './bruch';


export interface EigentumanteilVersionDetailEntryMeta { 
    histInfo?: HistInfoMeta;
    mHistInfo?: FieldMetaData;
    quoteAlsText?: string;
    mQuoteAlsText?: FieldMetaData;
    eigentumanteilArt?: EigentumanteilVersionDetailEntryMeta.EigentumanteilArtEnum;
    mEigentumanteilArt?: FieldMetaData;
    id: EigentumanteilVersionIdMeta;
    mId?: FieldMetaData;
    parzellenindex?: number;
    mParzellenindex?: FieldMetaData;
    rechtBemerkungNichtOeffentlich?: string;
    mRechtBemerkungNichtOeffentlich?: FieldMetaData;
    rechtBemerkung?: string;
    mRechtBemerkung?: FieldMetaData;
    quoteUnbekannt?: boolean;
    mQuoteUnbekannt?: FieldMetaData;
    quote?: Bruch;
    mQuote?: FieldMetaData;
    eigentumsform?: EigentumanteilVersionDetailEntryMeta.EigentumsformEnum;
    mEigentumsform?: FieldMetaData;
}
export namespace EigentumanteilVersionDetailEntryMeta {
    export type EigentumanteilArtEnum = 'GRUNDSTUECK' | 'PERSON' | 'HERRENLOS';
    export const EigentumanteilArtEnum = {
        GRUNDSTUECK: 'GRUNDSTUECK' as EigentumanteilArtEnum,
        PERSON: 'PERSON' as EigentumanteilArtEnum,
        HERRENLOS: 'HERRENLOS' as EigentumanteilArtEnum
    };
    export type EigentumsformEnum = 'ALLEINEIGENTUM' | 'MITEIGENTUM' | 'GESAMTEIGENTUM';
    export const EigentumsformEnum = {
        ALLEINEIGENTUM: 'ALLEINEIGENTUM' as EigentumsformEnum,
        MITEIGENTUM: 'MITEIGENTUM' as EigentumsformEnum,
        GESAMTEIGENTUM: 'GESAMTEIGENTUM' as EigentumsformEnum
    };
}


